export default "__VITE_ASSET__Dcz2C9z1__"